import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIngeregeld = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M16.02 16.43C16.02 16.15 15.8 15.93 15.52 15.93H12.91L14.24 13.66C14.38 13.42 14.3 13.11 14.06 12.97C13.82 12.83 13.51 12.91 13.37 13.15L12.04 15.43L10.71 13.15C10.57 12.91 10.26 12.83 10.02 12.97C9.78004 13.11 9.70004 13.42 9.84004 13.66L11.17 15.93H8.54004C8.26004 15.93 8.04004 16.15 8.04004 16.43C8.04004 16.71 8.26004 16.93 8.54004 16.93H11.17L9.84004 19.2C9.70004 19.44 9.78004 19.75 10.02 19.89C10.1 19.94 10.19 19.96 10.27 19.96C10.44 19.96 10.61 19.87 10.7 19.71L12.03 17.43L13.36 19.71C13.45 19.87 13.62 19.96 13.79 19.96C13.88 19.96 13.96 19.94 14.04 19.89C14.28 19.75 14.36 19.44 14.22 19.2L12.89 16.93H15.52C15.8 16.93 16.02 16.71 16.02 16.43Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.27 10.66C18.8 10.19 18.17 9.92996 17.5 9.92996H17V5.95996C17 4.61996 16.48 3.36996 15.54 2.41996C14.6 1.47996 13.34 0.959961 12 0.959961C10.66 0.959961 9.41 1.47996 8.46 2.41996C7.52 3.35996 7 4.61996 7 5.95996V9.92996H6.5C5.83 9.92996 5.21 10.19 4.73 10.66C4.25 11.13 4 11.76 4 12.43V20.43C4 21.1 4.26 21.73 4.73 22.2C5.2 22.67 5.83 22.93 6.5 22.93H17.5C18.17 22.93 18.79 22.67 19.27 22.2C19.75 21.73 20 21.1 20 20.43V12.43C20 11.76 19.74 11.13 19.27 10.66ZM8 5.95996C8 4.88996 8.42 3.88996 9.17 3.12996C9.92 2.36996 10.93 1.95996 12 1.95996C13.07 1.95996 14.07 2.37996 14.83 3.12996C15.59 3.87996 16 4.88996 16 5.95996V9.92996H8V5.95996ZM19 20.43C19 20.83 18.84 21.21 18.56 21.49C18.28 21.77 17.9 21.93 17.5 21.93H6.5C6.1 21.93 5.72 21.77 5.44 21.49C5.16 21.21 5 20.83 5 20.43V12.43C5 12.03 5.16 11.65 5.44 11.37C5.72 11.09 6.1 10.93 6.5 10.93H17.5C17.9 10.93 18.28 11.09 18.56 11.37C18.84 11.65 19 12.03 19 12.43V20.43Z'
    />
  </svg>
);
export default SvgIngeregeld;
